module.exports = __webpack_public_path__ + "static/media/departure-icon.5667418b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/departure-icon.svg
// module id = 673
// module chunks = 0